import React from 'react';
import { Space, Button, Tooltip } from 'antd';
import { PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons';

export default function AccionesPagosV2({
  onCrearOrdenPago,
  accionesProps
}) {
  return (
    <Space>
      <Tooltip title="Buscar asistencias para crear OP">
        <Button
          type="default"
          icon={<PlusCircleOutlined />}
          onClick={onCrearOrdenPago}
        >
          Crear Orden de Pago
        </Button>
      </Tooltip>
      <Tooltip title="Actualizar desde servidor">
        <Button
          type="default"
          icon={<ReloadOutlined />}
          {...accionesProps.refresh}
        >
        </Button>
      </Tooltip>
    </Space>
  );
}
